import { render, staticRenderFns } from "./CreateTestEx.vue?vue&type=template&id=70d20010&shadow"
import script from "./CreateTestEx.vue?vue&type=script&lang=js&shadow"
export * from "./CreateTestEx.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports